import { render, staticRenderFns } from "./TabBase.vue?vue&type=template&id=fcf10e12&scoped=true&lang=pug&"
import script from "./TabBase.vue?vue&type=script&lang=ts&"
export * from "./TabBase.vue?vue&type=script&lang=ts&"
import style0 from "./TabBase.vue?vue&type=style&index=0&id=fcf10e12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf10e12",
  null
  
)

export default component.exports